import React, { memo } from 'react';
import { Segment } from 'semantic-ui-react';
import { Opportunity as OpportunityComponent } from './Opportunity';


var Line = function () { return React.createElement("div", { className: 'line' }); };
var Opportunities = memo(function (_a) {
    var itemOpportunities = _a.itemOpportunities, onOpportunityClick = _a.onOpportunityClick, className = _a.className;
    return (React.createElement(Segment, { className: "Opportunities pluggy " + (className || '') }, itemOpportunities.map(function (opportunity, index) { return (React.createElement("div", { key: opportunity.id },
        React.createElement(OpportunityComponent, { opportunity: opportunity, onOpportunityClick: onOpportunityClick }),
        index !== itemOpportunities.length - 1 && React.createElement(Line, null))); })));
});
export { Opportunities };
